module.exports = global["jQuery"] = require("-!E:\\dev\\repos\\wpo_site\\node_modules\\jquery\\dist\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 42
// module chunks = 2